:root {
  --g-top-bar-height: 48px;
  --g-mobile-top: 59px;
  --g-mobile-bottom: 94px;
  --g-mobile-preview-max-height: 512px; }

._publishPipeline_jskay_7 ._devPanelWrapper_jskay_7 .control-base-modal-body {
  padding-bottom: 12px; }

._publishPipeline_jskay_7 ._devUI_jskay_10 ._text_jskay_10 {
  margin-bottom: 42px; }

._publishPipeline_jskay_7 ._devUI_jskay_10 ._controls_jskay_13 {
  display: flex;
  margin-bottom: 30px; }
  ._publishPipeline_jskay_7 ._devUI_jskay_10 ._controls_jskay_13 ._checkboxWrapper_jskay_16 {
    width: 346px;
    align-self: center; }
    ._publishPipeline_jskay_7 ._devUI_jskay_10 ._controls_jskay_13 ._checkboxWrapper_jskay_16 svg:not(:root) {
      overflow: visible; }
  ._publishPipeline_jskay_7 ._devUI_jskay_10 ._controls_jskay_13 ._buttons_jskay_21 {
    display: flex;
    gap: 10px;
    justify-content: space-between; }

._publishPipeline_jskay_7 ._devUI_jskay_10 ._footerLink_jskay_26 ._divider_jskay_26 {
  margin: 0 -30px 10px; }

._publishPipeline_jskay_7 ._devUI_jskay_10 ._footerLink_jskay_26 ._link_jskay_29 {
  display: flex;
  justify-content: center; }

._publishPipeline_jskay_7 .control-base-modal-footer {
  align-items: center; }

._publishPipeline_jskay_7 .control-message-modal.control-message-modal.with-illustration,
._publishPipeline_jskay_7 .control-custom-modal.control-custom-modal {
  width: 600px; }
